/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

export enum TSBeitragType {
    SCHADENFALL = <any> 'SCHADENFALL',
    VERSICHERUNG = <any> 'VERSICHERUNG',
}

export function getTSBeitragTypeValues(): Array<TSBeitragType> {
    return [
        TSBeitragType.SCHADENFALL,
        TSBeitragType.VERSICHERUNG
    ];
}

export function beitragArtPrefix(): string {
    return 'TSBeitragType_';
}

export function beitragPropertySuffix(): string {
    return '_BEITRAG';
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSBeitragType.ts